import React from 'react';
import { format, addDays } from 'date-fns';

const DateRangePicker = ({ dateRange, onDateRangeChange }) => {
  const handleQuickSelectTwoWeeks = () => {
    const today = new Date();
    const start = today;
    const end = addDays(today, 13);
    onDateRangeChange('start', format(start, 'yyyy-MM-dd'));
    onDateRangeChange('end', format(end, 'yyyy-MM-dd'));
  };

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="mb-4 text-lg font-medium text-gray-900">Date Range</h3>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">Start Date</label>
          <input
            type="date"
            value={format(dateRange.start, 'yyyy-MM-dd')}
            onChange={(e) => onDateRangeChange('start', e.target.value)}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">End Date</label>
          <input
            type="date"
            value={format(dateRange.end, 'yyyy-MM-dd')}
            onChange={(e) => onDateRangeChange('end', e.target.value)}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={handleQuickSelectTwoWeeks}
          className="inline-flex items-center rounded-md border border-blue-500 bg-blue-50 px-3 py-1 text-sm font-medium text-blue-700 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Select Coming 2 Weeks
        </button>
      </div>
    </div>
  );
};

export default DateRangePicker;
